module.exports = __webpack_public_path__ + "static/media/Logo.3b65f833.svg";